import TemplateService from '../../../../AppSettings/services/TemplateService';
import { MESSAGES } from '../Utils/constants';

/**
 * Hook to manage template table operations
 * Note: Custom tables now use TableBuilder for all editing
 */
export const useTableOperations = (selectedTable, selectedTableData, refreshTableData, setErrorMessage) => {
  // Get current rows for template tables only
  const getCurrentRows = () => {
    return Array.isArray(selectedTableData) ? selectedTableData : [];
  };

  // Delete row operation (template tables only)
  const handleDeleteRow = async (rowOrIndex) => {
    if (!window.confirm('Are you sure you want to delete this row?')) return;

    try {
      const rowId = typeof rowOrIndex === 'object' ? rowOrIndex.id : rowOrIndex;
      if (!rowId) {
        console.error('No valid ID found for row deletion');
        setErrorMessage('Unable to delete row. No valid ID found.');
        return;
      }
      await TemplateService.deleteRowFromTemplate(selectedTable.table_name, rowId);
      refreshTableData();
    } catch (error) {
      console.error("Error deleting row:", error);
      setErrorMessage(MESSAGES.ERRORS.DELETE_ROW);
    }
  };

  return {
    // Actions
    handleDeleteRow,
    
    // Helpers
    getCurrentRows
  };
};
